/*
* 打印模板设置
* */
export const GETPRINTTEMPLATEPAGE = 'GETPRINTTEMPLATEPAGE'
export const DROPDOWNLIST = 'DROPDOWNLIST'
export const COPYPRINTTEMPLATE = 'COPYPRINTTEMPLATE'
export const DELETEPRINTTEMPLATE = 'DELETEPRINTTEMPLATE'
export const SETPRINTTEMPLATEDEF = 'SETPRINTTEMPLATEDEF'
export const GETSYSTEMP = 'GETSYSTEMP' // 系统模板
export const GETTEMPDATA = 'GETTEMPDATA' // 编辑时获取模板数据
export const SAVETEMPDATA = 'SAVETEMPDATA' // 保存模板数据



// WEBPACK FOOTER //
// ./src/store/printTemplate/types.js